
export const REQUEST_DATA_PENDING   = "REQUEST_DATA_PENDING";
export const REQUEST_DATA_SUCCESS   = "REQUEST_DATA_SUCCESS";
export const REQUEST_DATA_ERROR     = "REQUEST_DATA_ERROR";

